import React from 'react';
import './HomePage.css';
import TopFold from './TopFold.js';
import Locations from './Locations';
import Classes from './Classes';
import AboutUs from './AboutUs';
import Contact from './Contact';
import Review from './Review';
import logo from '../assets/images1/AJKU-Logo-v1.png';
import Beach1 from '../assets/images1/15.png';
import Beach2 from '../assets/images1/11.png';
import SenseiBeach from '../assets/images1/8.png';
import Sensei2 from '../assets/images1/3.png';
import Sensei3 from '../assets/images1/4.png';
import StockPhoto1 from '../assets/images1/13.png';
import StockPhoto2 from '../assets/images1/14.png';
import Sosai from '../assets/images1/10.png';
import KarateWoman from '../assets/images1/16.png';
import Group1 from '../assets/images1/9.png';
import Group2 from '../assets/images1/1.png';
import FemaleKicking from '../assets/images1/12.png';
import SenseiIan from '../assets/images1/6.png';
import Tully from '../assets/images1/5.png';
import unknownKyokushin from '../assets/images1/2.png';
import Ritchie_Rocky from '../assets/images1/7.png';
import ImageSlideshow from '../ImageSlideShow'; // Import the new component

const HomePage = () => {
    const slideshowImages = [
        { src: StockPhoto1, alt: "Karate Practitioner" },
        { src: StockPhoto2, alt: "Karate Practitioner" },
        { src: SenseiBeach, alt: "Karate Practitioner" },
        { src: Sensei2, alt: "Karate Practitioner" },
        { src: Sensei3, alt: "Karate Practitioner" },
        { src: Beach1, alt: "Karate Practitioner" },
        { src: Beach2, alt: "Karate Practitioner" },
        { src: Group1, alt: "Karate Practitioner" },
        { src: Group2, alt: "Karate Practitioner" },
        { src: FemaleKicking, alt: "Karate Practitioner" },
        { src: SenseiIan, alt: "Karate Practitioner" },
        { src: Tully, alt: "Karate Practitioner" },
        { src: unknownKyokushin, alt: "Karate Practitioner" },
        { src: Sosai, alt: "Karate Practitioner" },
        { src: KarateWoman, alt: "Karate Practitioner" },
        { src: Ritchie_Rocky, alt: "Karate Practitioner" }
        // Add more images here
        // { src: anotherImage, alt: "Another Karate Image" },
        // { src: thirdImage, alt: "Third Karate Image" },
      ];
      
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      };
  
    return (
        <div className="cafe-homepage">
            <TopFold />
            <div className="hero-section">
                <div className="hero-image-container">
                    <ImageSlideshow images={slideshowImages} />
                </div>
                <div className="hero-content">
                    <h1>Traditional Kyokushin Karate</h1>
                    <h2>Discipline, Fighting, Flexibility, Mobility, Strength, Confidence, Friendship</h2>
                    <p>Master the art of Kyokushin Karate and transform your body and mind.</p>
                    <button className="join-button" onClick={() => scrollToSection('contact')}>Contact Us</button>
                </div>
            </div>
            <div className="main-content">
                <Locations />
                <Classes />
                <AboutUs />
                <Contact />
                {/* <Review /> */}
            </div>
        </div>
    );
};

export default HomePage;